<div class="household-parent-grid" [formGroup]="formGroup">
  <div class="household-parent-header">
    <h5 class="household-section-title">Parent Information</h5>
  </div>
  <div class="household-parent-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="firstName" class="field-label">First name</label>
      <mat-form-field class="household-fields">
        <input id="firstName"
               matInput
               type="text"
               placeholder="First name"
               class="user-record-field-input"
               formControlName="firstName" />
        @if (formGroup.get('firstName')?.invalid && formGroup.get('firstName')?.touched) {
          @if (formGroup.get('firstName')?.hasError('required')) {
            <mat-error>First name is required</mat-error>
          } @else if (formGroup.get('firstName')?.hasError('name')) {
            <mat-error>{{ formGroup.get('firstName')?.getError('name')?.message ?? 'First name format is invalid' }}</mat-error>
          } @else {
            <mat-error>First name is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  <div class="household-parent-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="middleName" class="field-label">Middle name</label>
      <mat-form-field class="household-fields">
        <input id="middleName"
               matInput
               type="text"
               placeholder="Middle name"
               class="user-record-field-input"
               formControlName="middleName" />
        @if (formGroup.get('middleName')?.invalid && formGroup.get('middleName')?.touched) {
          @if (formGroup.get('middleName')?.hasError('name')) {
            <mat-error>{{ formGroup.get('middleName')?.getError('name')?.message ?? 'Middle name format is invalid' }}</mat-error>
          } @else {
            <mat-error>Middle name is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  <div class="household-parent-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="lastName" class="field-label">Last name</label>
      <mat-form-field class="household-fields">
        <input id="lastName"
               matInput
               type="text"
               placeholder="Last name"
               class="user-record-field-input"
               formControlName="lastName" />
        @if (formGroup.get('lastName')?.invalid && formGroup.get('lastName')?.touched) {
          @if (formGroup.get('lastName')?.hasError('required')) {
            <mat-error>Last name is required</mat-error>
          } @else if (formGroup.get('lastName')?.hasError('name')) {
            <mat-error>{{ formGroup.get('lastName')?.getError('name')?.message ?? 'Last name format is invalid' }}</mat-error>
          } @else {
            <mat-error>Last name is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  <div class="household-parent-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="pidNumber" class="field-label">PID</label>
      <input
        id="pidNumber"
        matInput
        type="text"
        placeholder="PID"
        class="user-record-field-input"
        formControlName="pidNumber" />
    </div>
  </div>
  <div class="household-parent-field half-width">
    <div class="user-record-field-wrapper">
      <label for="birthDate" class="field-label">Parent Birth Date</label>
      <mat-form-field class="household-fields">
        <div class="user-record-datepicker-wrapper">
          <input id="birthDate"
                 matInput
                 [matDatepicker]="birthDatePicker"
                 placeholder="MM/DD/YYYY"
                 class="user-record-field-input"
                 formControlName="birthDate" 
                 readonly
                 (click)="birthDatePicker.open()"/>
          <mat-datepicker-toggle matIconSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #birthDatePicker startView="year"></mat-datepicker>
        </div>
        @if (formGroup.get('birthDate')?.invalid && formGroup.get('birthDate')?.touched) {
          @if (formGroup.get('birthDate')?.hasError('required')) {
            <mat-error>Parent Birth Date is required</mat-error>
          } @else if (formGroup.get('birthDate')?.hasError('futureDate')) {
            <mat-error>Parent Birth Date must be in the past</mat-error>
          } @else {
            <mat-error>Parent Birth Date is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  <div class="household-parent-field half-width">
    <div class="user-record-field-wrapper">
      <label for="ssn" class="field-label">Parent Social Security</label>
      <mat-form-field class="household-fields">
        <input id="ssn"
               matInput
               type="text"
               [mask]="'000-00-0000'"
               placeholder="XXX-XX-XXXX"
               class="user-record-field-input"
               formControlName="ssn" />
        @if (formGroup.get('ssn')?.invalid && formGroup.get('ssn')?.touched) {
        <mat-error>Parent Social Security is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</div>
